<template>
    <div class="container mt-5">
        <div>
            <div class="table-responsive">
                <table class="table table-hover table-bordered">
                    <tbody v-for="category in categories">
                    <tr class="text-center">
                        <th colspan="2">{{category.nombre}}</th>
                    </tr>
                    <tr v-for="treatment in category.tratamientos">
                        <td>{{treatment.name}}</td>
                        <td>{{treatment.price}}</td>
                    </tr>
                    </tbody>

                </table>

            </div>
        </div>
    </div>
</template>

<script>
import config from '../config/index';
    export default {
        data() {
            return {
                categories: []
            }
        },
        created() {
            this.index();
        },
        methods: {
            index () {
                axios.get(config.urlBase +'/api/v1/public/categories')
                    .then(res => {
                        this.categories = res.data.data;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/DutyComponent.vue